module.exports = __webpack_public_path__ + "img/master_icon.59f4a215.png";